var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicroscope(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.009,
    height: 23.259,
    viewBox: "0 0 17.009 23.259",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_163084",
    "data-name": "Grupo 163084",
    transform: "translate(17296.02 18251.707)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27364",
    "data-name": "Caminho 27364",
    d: "M272.921,195.772,271.148,194a.353.353,0,0,1-.035-.039l-.243.247a.7.7,0,0,0,0,1l.938.945a.7.7,0,0,0,.5.2c.415,0,.567-.307.751-.458a1.535,1.535,0,0,1-.141-.127Z",
    transform: "translate(-17561.574 -18437.725)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27365",
    "data-name": "Caminho 27365",
    d: "M157.763,270.055a.563.563,0,0,0,.564-.564v-1.177a.566.566,0,0,0-.564-.564h-5.915a.566.566,0,0,0-.564.564v1.177a.563.563,0,0,0,.564.564Z",
    transform: "translate(-17447.303 -18508.354)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27366",
    "data-name": "Caminho 27366",
    d: "M292.618,38.19l-4.751,4.751a.885.885,0,0,0,0,1.251l1.777,1.777a.881.881,0,0,0,1.251,0l4.72-4.717.031-.031a.762.762,0,0,0,0-1.075l-1.953-1.953a.778.778,0,0,0-1.075,0Z",
    transform: "translate(-17577.791 -18288.412)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27367",
    "data-name": "Caminho 27367",
    d: "M221.91,140.84l-.028.028-1.667,1.667a4.727,4.727,0,1,1-6.6,6.746h-2.873a7.121,7.121,0,1,0,11.167-8.442Z",
    transform: "translate(-17504.217 -18386.875)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27368",
    "data-name": "Caminho 27368",
    d: "M443.977,8.5a.737.737,0,0,0-1.022,0l-.807.814,1.942,1.942.807-.814a.723.723,0,0,0,0-1.022Z",
    transform: "translate(-17725.719 -18260.004)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27369",
    "data-name": "Caminho 27369",
    d: "M205.364,400.5a6.652,6.652,0,0,0-1.456,3.211h13.208a6.723,6.723,0,0,0-1.413-3.155,7.808,7.808,0,0,1-10.338-.056Z",
    transform: "translate(-17497.674 -18635.422)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27370",
    "data-name": "Caminho 27370",
    d: "M183.27,492H168.377a.708.708,0,0,0-.708.709v1.139a.709.709,0,0,0,.708.709H183.27a.711.711,0,0,0,.709-.709v-1.139A.711.711,0,0,0,183.27,492Z",
    transform: "translate(-17462.988 -18723.004)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicroscope);
export default __webpack_public_path__ + "static/media/microscope.493273c148f14cf9fd19dbea9d862341.svg";
export { ForwardRef as ReactComponent };